import React, { useEffect, useState } from "react";
import useFetch from "../Hooks/useFetch";
import { missionsURL, submissionsURL } from "../Hooks/URL";
import { useParams } from "react-router-dom";
import PreviewExam from "../Templates/Home/Missions/PreviewExam/PreviewExam";

function PreviewExamPage() {
  const { id, submissionId } = useParams();
  const [isSubmission, setIsSubmission] = useState(submissionId ? true : false);
  const url = isSubmission
    ? `${submissionsURL}/${submissionId}`
    : `${missionsURL}/${id}`;

  const [submission, setSubmission] = useState(null);
  const { data, loading, error } = useFetch(url);

  useEffect(() => {
    if (!loading && !error && data) {
      // For submission mode, pass the entire response object to preserve status and data structure
      // For preview mode, pass data.data (the mission object)
      setSubmission(data?.data);
    }
  }, [data, loading, error, isSubmission]);

  return (
    <PreviewExam
      submission={submission}
      loading={loading || !submission}
      isSubmission={isSubmission}
    />
  );
}

export default PreviewExamPage;
